import { XDropdownSearchSelection } from '@adornis/popover/x-dropdown-search-selection.js';
import { customElement, property } from 'lit/decorators.js';

/*
 * @element tr-dropdown-search-selection
 */
@customElement('tr-dropdown-search-selection')
export class TrDropdownSearchSelection<T, V> extends XDropdownSearchSelection<T, V> {
  @property({ attribute: 'empty-state-with-search' }) emptyStateWithSearch?: string;
  @property({ attribute: 'empty-state-without-search' }) emptyStateWithoutSearch?: string;

  override get emptyState() {
    return this._searchString.value ? this.emptyStateWithSearch : this.emptyStateWithoutSearch;
  }

  override set emptyState(value: string) {}
}
